import {TranslateService} from '@ngx-translate/core';

import {Scss} from '../../shared/utils/scss';

export const getOldWorkflowsConfig = (
  workflowTypes: {key: string }[],
  countByType: {[key: string]: number},
  resolvedStatusColors: {[key: string]: string},
  translate: TranslateService
) => {
  const oldWorkflowsTotal = Object.values(countByType).reduce((sum, current) => sum + current, 0);

  const innerPieData = workflowTypes.map(type => {
    return {
      name: translate.instant(type.key),
      type: type.key,
      value: countByType[type.key],
      itemStyle: {
        normal: {
          color: resolvedStatusColors[type.key] || Scss.variable('chart-fallback')
        }
      },
      label: {normal : {show: false}},
      labelLine: {normal : {show: false}}
    };
  });


  return {
    title: [
      {
        text: translate.instant('PROCESS_MONITOR.old_processes_chart_title'),
        left: 'center',
        top: '1%',
        textStyle: {
          fontSize: 18,
          fontWeight: 'bold',
          color: '#333'
        }
      },
      {
        text: oldWorkflowsTotal.toString(),
        top: '44%',
        left: '69%',
        textAlign: 'center',
        textStyle: {
          fontSize: 28,
          fontWeight: 'bold',
          color: '#333'
        }
      }
    ],
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        if (params.seriesType === 'pie') {
            if (params.seriesName === translate.instant('PROCESS_MONITOR.old_processes_chart_title')) {
            return `${params.name}: <br/><strong>${params.value}</strong>`;
          } else if (params.seriesName === translate.instant('PROCESS_MONITOR.process_by_type_chart_title')) {
            return `<strong>${params.name}</strong><br/>${params.value} (${params.percent}%)`;
          }
        }
        return '';
      }
    },
    legend: {
      show: true,
      orient: 'vertical',
      top: '15%',
      itemGap: 3,
      textStyle: {
        fontSize: 12
      },
      left: 'left',
      data: innerPieData.map(item => item.name)
    },
    series: [
      {
        name: translate.instant('PROCESS_MONITOR.old_processes_chart_title'),
        type: 'pie',
        radius: ['40%', '60%'],
        center: ['70%', '50%'],
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 2
        },
        data: [
          {
            value: oldWorkflowsTotal,
            name: translate.instant('PROCESS_MONITOR.one_month_older'),
            itemStyle: {
              normal: {color: Scss.variable('chart-highlight')}
            }
          }
        ]
      },
      {
        name: translate.instant('PROCESS_MONITOR.process_by_type_chart_title'),
        type: 'pie',
        radius: ['30%', '45%'],
        center: ['70%', '50%'],
        data: innerPieData
      }
    ]
  };
};

